import { render } from "./DialogObservationSeatWarning.vue?vue&type=template&id=06fa3ff6&scoped=true"
import script from "./DialogObservationSeatWarning.vue?vue&type=script&lang=js"
export * from "./DialogObservationSeatWarning.vue?vue&type=script&lang=js"

import "./DialogObservationSeatWarning.vue?vue&type=style&index=0&id=06fa3ff6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-06fa3ff6"

export default script